import { useState, useEffect } from "react";
import { useAuth } from "hooks/useAuth";
import { useFormik } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  FormControl,
  FormLabel,
  Grid,
  Button,
  InputGroup,
  Icon,
  InputRightElement,
  Box,
  Input,
  Alert,
  AlertIcon,
  Stack,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import api from "services/api";

interface perfil {
  isAdmin: boolean;
}

const Perfil = ({ isAdmin }: perfil) => {
  const [changePassword, setChangePassword] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [passLetra, setPassLetra] = useState(true);
  const [passMinimo6, setPassMinimo6] = useState(true);
  const [passNumero, setPassNumero] = useState(true);
  const [passPassword, setPassPassword] = useState(true);

  const { user, setUser } = useAuth();

  function validatePassword(value: string) {
    setPassLetra(false);
    setPassNumero(false);
    setPassMinimo6(false);
    if (!/(?=.*[A-Za-z])/.test(value)) {
      setPassLetra(true);
    }
    if (!/(?=.*?[0-9])/.test(value)) {
      setPassNumero(true);
    }
    if (!/^.{6,}$/.test(value)) {
      setPassMinimo6(true);
    }
  }

  function validatePasswordConfirmed(value: string) {
    setPassPassword(false);
    if (
      (formik.values.password !== value && formik.values.password2 !== value) ||
      (formik.values.password2 !== value &&
        formik.values.password.length < 1) ||
      formik.values.password2.length < 1
    ) {
      setPassPassword(true);
    }
  }

  useEffect(() => {
    if (user?.fl_primeiro_acesso && !isAdmin) {
      setChangePassword(true);
      Swal.fire({
        icon: "warning",
        title: `Olá ${user?.nome}, escolha uma nova senha para continuar usando o sistema.`,
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
  }, [user, isAdmin]);

  const formik = useFormik({
    initialValues: {
      password: "",
      password2: "",
    },
    onSubmit: async (values, actions) => {
      if (passLetra || passMinimo6 || passNumero || passPassword) {
        return;
      }
      actions.setSubmitting(true);

      const data = {
        password: values.password,
        fl_primeiro_acesso: false,
      };

      await api
        .put(`/users/${user?.id}`, data)
        .then((res) => {
          formik.resetForm();
          setChangePassword(false);
          setUser(res.data);
          setPassLetra(true);
          setPassNumero(true);
          setPassMinimo6(true);
          setPassPassword(true);
          setShow(false);
          setShow2(false);
          Swal.fire({
            icon: "success",
            title: "Senha alterada com sucesso",
            showConfirmButton: false,
            timer: 3000,
          }).then((res) => {
            actions.setSubmitting(false);
            if (res.isDismissed) {
              // setCloseModal(onClose);
            }
            formik.resetForm();
          });
        })
        .catch((error) => {
          console.log("erro: ", error);
          actions.setSubmitting(false);
          Swal.fire({
            icon: "warning",
            title:
              "Algo deu errado! Entre em contato com o administrador do sistema",
            showConfirmButton: true,
            confirmButtonText: `Ok`,
          });
        });
    },
  });

  return (
    <Box
      position="relative"
      maxWidth="400px"
      width="100%"
      margin="30px"
      height="max-content"
      backgroundColor="#fff"
      padding="15px"
      boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
    >
      <form
        style={{ width: "100%", height: "100%" }}
        onReset={formik.handleReset}
        onSubmit={formik.handleSubmit}
      >
        <Grid gap={6}>
          {(!user?.fl_primeiro_acesso || isAdmin) && (
            <>
              <FormControl>
                <FormLabel htmlFor="nome">Nome</FormLabel>
                <Input
                  isReadOnly
                  id="nome"
                  name="nome"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={user?.nome}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="email">E-mail</FormLabel>
                <Input
                  isReadOnly
                  id="email"
                  name="email"
                  type="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={user?.email}
                />
              </FormControl>
            </>
          )}
          {changePassword && (
            <>
              <FormControl isInvalid={passLetra || passMinimo6 || passNumero}>
                <FormLabel htmlFor="password">
                  Nova senha <span style={{ color: "#E53E3E" }}>*</span>
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    autoComplete="true"
                    id="password"
                    name="password"
                    type={show ? "text" : "password"}
                    onChange={(e) => {
                      formik.handleChange(e);
                      validatePassword(e.target.value);
                      validatePasswordConfirmed(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  <InputRightElement width="3rem" cursor="pointer">
                    <Box h="1.75rem" size="sm" onClick={() => setShow(!show)}>
                      {show ? <Icon as={FaEyeSlash} /> : <Icon as={FaEye} />}
                    </Box>
                  </InputRightElement>
                </InputGroup>
                <Stack spacing={1} marginTop="5px">
                  <Alert
                    status={passLetra ? "warning" : "success"}
                    borderRadius="5px"
                    padding="5px 10px"
                  >
                    <AlertIcon />
                    Deve conter pelo menos uma letra
                  </Alert>
                  <Alert
                    status={passNumero ? "warning" : "success"}
                    borderRadius="5px"
                    padding="5px 10px"
                  >
                    <AlertIcon />
                    Deve conter pelo menos um número
                  </Alert>
                  <Alert
                    status={passMinimo6 ? "warning" : "success"}
                    borderRadius="5px"
                    padding="5px 10px"
                  >
                    <AlertIcon />
                    Deve conter no mínimo 6 caracteres
                  </Alert>
                </Stack>
              </FormControl>
              <FormControl isInvalid={passPassword}>
                <FormLabel htmlFor="password2">
                  Confirme a senha <span style={{ color: "#E53E3E" }}>*</span>
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    autoComplete="true"
                    id="password2"
                    name="password2"
                    type={show2 ? "text" : "password"}
                    onChange={(e) => {
                      formik.handleChange(e);
                      validatePasswordConfirmed(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.password2}
                  />
                  <InputRightElement width="3rem" cursor="pointer">
                    <Box h="1.75rem" size="sm" onClick={() => setShow2(!show2)}>
                      {show2 ? <Icon as={FaEyeSlash} /> : <Icon as={FaEye} />}
                    </Box>
                  </InputRightElement>
                </InputGroup>
                <Alert
                  marginTop="5px"
                  status={passPassword ? "warning" : "success"}
                  borderRadius="5px"
                  padding="5px 10px"
                >
                  <AlertIcon />
                  As duas senhas devem ser iguais
                </Alert>
              </FormControl>
            </>
          )}
          <Box display="flex" justifyContent="flex-end">
            {!changePassword ? (
              <Button
                width="130px"
                colorScheme="blue"
                fontWeight="100"
                onClick={() => setChangePassword(true)}
                type="reset"
              >
                Alterar senha
              </Button>
            ) : (
              <>
                <Button
                  width="130px"
                  marginRight="10px"
                  colorScheme="blue"
                  fontWeight="100"
                  isLoading={formik.isSubmitting}
                  disabled={
                    passLetra || passMinimo6 || passNumero || passPassword
                  }
                  type="submit"
                >
                  Salvar
                </Button>
                {(!user?.fl_primeiro_acesso || isAdmin) && (
                  <Button
                    width="130px"
                    fontWeight="100"
                    type="reset"
                    colorScheme="facebook"
                    onClick={() => {
                      setPassLetra(true);
                      setPassNumero(true);
                      setPassMinimo6(true);
                      setPassPassword(true);
                      formik.handleReset("");
                      setChangePassword(false);
                      setShow(false);
                      setShow2(false);
                    }}
                  >
                    Cancelar
                  </Button>
                )}
              </>
            )}
          </Box>
        </Grid>
      </form>
    </Box>
  );
};

export default Perfil;
